import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { episodeOfCareAction } from '../../actions/constant';
import episodeOfCareService from '../../../services/apiServices/episodeOfCare/episodeOfCare';
const {
  EDIT_EPISODE_OF_CARE_REQUEST,
  EDIT_EPISODE_OF_CARE_SUCCESS,
  EDIT_EPISODE_OF_CARE_FAILURE,
} = episodeOfCareAction;

function* updateEpisodeOfCare(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(episodeOfCareService.editEpisodeOfCare, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: EDIT_EPISODE_OF_CARE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: EDIT_EPISODE_OF_CARE_FAILURE, payload: error });
  }
}

function* updateEpisodeOfCareSaga() {
  yield takeEvery(EDIT_EPISODE_OF_CARE_REQUEST,updateEpisodeOfCare)
}

export default updateEpisodeOfCareSaga;
